import React from 'react';
import './style.less';

const OrganizationLogo = ({
  name,
  logo,
  className = '',
}) => {
  return (
    <div className={`OrganizationLogo ${className}`}>
      <img src={logo} alt={name} />
    </div>
  );
}

export default OrganizationLogo;
